import { Alert, ButtonLink } from '@designsforhealth/dfh-react-components'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import styled from 'styled-components'

import useLogAndCaptureError from '../../../../hooks/useLogAndCaptureError'
import { useChangePassword } from '../../../../lib/auth/hooks/useChangePassword'
import ContactSupportMessage from '../../../ContactSupportMessage'
import InlineSpinner from '../../../InlineSpinner'
import Spacer from '../../../Spacer'

const StyledButtonLink = styled(ButtonLink)`
  color: ${({ theme }) => theme.colors.brand.red};
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
`

const StyledEmail = styled.span`
  text-decoration: underline;
  user-select: all;
  white-space: nowrap;
`

const ChangePassword: React.FC = () => {
  const [changePassword, { data, loading, error }] = useChangePassword()
  useLogAndCaptureError(error)

  return (
    <>
      {!data ? (
        <div>
          Click{' '}
          <StyledButtonLink text="here" onClick={changePassword} disabled={loading} underline /> if
          you&apos;d like to change your password.
        </div>
      ) : (
        <div>
          <FontAwesomeIcon icon={faCheckCircle} /> We&apos;ve just sent you an email at{' '}
          <StyledEmail>{data.email}</StyledEmail> to reset your password.
        </div>
      )}
      <InlineSpinner loading={loading} />
      {error && (
        <>
          <Spacer size={4} />
          <Alert type={'error'}>
            An error occurred sending your password reset email, and we have been notified.{' '}
            <ContactSupportMessage />
          </Alert>
        </>
      )}
    </>
  )
}

export default ChangePassword
